export default "__VITE_ASSET__B1FAC88U__"